import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询FBA渠道
export function listFbaChannel(requestBody) {
  return request({
    url: URL.fba.listFbaChannel,
    method: 'post',
    data: requestBody
  })
}

// 新增或更新FBA渠道
export function saveFbaChannel(requestBody) {
  return request({
    url: URL.fba.saveFbaChannel,
    method: 'post',
    data: requestBody
  })
}

// 删除FBA渠道
export function deleteFbaChannel(requestBody) {
  return request({
    url: URL.fba.deleteFbaChannel,
    method: 'post',
    data: requestBody
  })
}

// 删除FBA渠道
export function updateActiveState(requestBody) {
  return request({
    url: URL.fba.updateActiveState,
    method: 'post',
    data: requestBody
  })
}

// 获取已使用过的FBA渠道
export function getUsedFbaChannel(requestBody) {
  return request({
    url: URL.fba.getUsedFbaChannel,
    method: 'post',
    data: requestBody
  })
}

// 获取FBA报价可以选择的FBA渠道
export function getQuotationAvailableChannels(requestBody) {
  return request({
    url: URL.fba.getQuotationAvailableChannels,
    method: 'post',
    data: requestBody
  })
}

// 获取业务可以选择的FBA渠道
export function getJobAvailableChannels(requestBody) {
  return request({
    url: URL.fba.getJobAvailableChannels,
    method: 'post',
    data: requestBody
  })
}
